import { apiClient } from './client';
import { ImageStyle, PaginatedResponse } from '../../types';

export interface CreateImageStyleRequest {
  code: string;
  name: string;
  description?: string;
  illustrationUrl?: string;
  status?: 'ACTIVE' | 'INACTIVE';
}

export interface UpdateImageStyleRequest extends Partial<CreateImageStyleRequest> {}

export interface GetImageStylesParams {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  code?: string;
  status?: string;
}

export const imageStylesApi = {
  getImageStyles: async (params?: GetImageStylesParams): Promise<PaginatedResponse<ImageStyle>> => {
    return apiClient.get<PaginatedResponse<ImageStyle>>('/api/v1/admin/image-styles', { params });
  },

  getImageStyleDetail: async (id: string): Promise<{ data: ImageStyle }> => {
    return apiClient.get<{ data: ImageStyle }>(`/api/v1/admin/image-styles/${id}`);
  },

  createImageStyle: async (data: CreateImageStyleRequest): Promise<{ data: ImageStyle }> => {
    return apiClient.post<{ data: ImageStyle }>('/api/v1/admin/image-styles', data);
  },

  updateImageStyle: async (id: string, data: UpdateImageStyleRequest): Promise<{ data: ImageStyle }> => {
    return apiClient.put<{ data: ImageStyle }>(`/api/v1/admin/image-styles/${id}`, data);
  },

  deleteImageStyle: async (id: string): Promise<{ data: {} }> => {
    return apiClient.delete<{ data: {} }>(`/api/v1/admin/image-styles/${id}`);
  },

  extractImageStyle: async (imageBase64: string): Promise<{ data: { suggestedName: string; description: string; illustrationUrl?: string } }> => {
    return apiClient.post<{ data: { suggestedName: string; description: string; illustrationUrl?: string } }>('/api/v1/admin/image-styles/extract', { imageBase64 });
  },
};
